/* Whose line is this (requirement 35, C1–C5). A speaker's colour in the chat is a SEAT colour:
   the people of the room — the game's players, or the lobby's members — sorted by user id, the
   n-th one takes CHAT_INKS[n % CHAT_INKS.length]. So two people in one room never share a colour
   while there are no more than eight, and every screen in the room gives a person the same one.

   The channel is not the colour any more: the ` · ALL` tag and the line's left border say that.
   None of the inks is the team green or the comms magenta, so a name never reads as a channel. */

export const CHAT_INKS = ["#f2b84b", "#7fb3ff", "#c49bff", "#4fd1c5", "#ff8fb1", "#b5e655", "#ffa36b", "#e0e0e0"]

// Somebody with no seat — a spectator in a game — is the eighth ink, the grey (C3).
export const UNSEATED_INK = CHAT_INKS[CHAT_INKS.length - 1]

// A player row and a lobby seat both carry the account as `user`; a bare user is accepted too.
const accountOf = (person) => person?.user ?? person

/* The ink for a speaker, or null when nothing can be said (no people known at all), in which case
   the caller keeps the old channel colour. `username` is the fallback for a line stored before
   messages carried an id (C5). */
export const chatInkFor = (userId, people, username = null) => {
  const accounts = (people || []).map(accountOf).filter((account) => account && account.id != null)
  if (!accounts.length) return null
  const seats = [...accounts].sort((a, b) => Number(a.id) - Number(b.id))
  if (userId == null) {
    // A line from before C1: the seat found by name, else the old channel colour (C5).
    const byName = username ? seats.findIndex((account) => account.username === username) : -1
    return byName < 0 ? null : CHAT_INKS[byName % CHAT_INKS.length]
  }
  const index = seats.findIndex((account) => String(account.id) === String(userId))
  if (index < 0) return UNSEATED_INK
  return CHAT_INKS[index % CHAT_INKS.length]
}
